import PropTypes from 'prop-types';

import './styles/flexStyles.css';

// Flex
const ContainerFlex = ({
  centerText,
  children,
  className,
  itemsAlignment,
  itemsDirection,
  itemsJustification,
}) => {
  const cssFlexDirection = {
    column: 'col',
    'column-reverse': 'col-reverse',
  };

  const alignItems = itemsAlignment ? `items-${itemsAlignment}` : '';
  const flexDirection = itemsDirection
    ? `flex-${cssFlexDirection[itemsDirection] || itemsDirection}`
    : '';
  const justifyContent = itemsJustification
    ? `justify-${itemsJustification}`
    : '';
  const cssTextCenter = centerText ? 'text-align-center' : '';

  return (
    <div
      className={`${className} flex flex-wrap ${alignItems} ${flexDirection} ${justifyContent} ${cssTextCenter}`.trim()}
    >
      {children}
    </div>
  );
};

ContainerFlex.defaultProps = {
  centerText: false,
  className: '',
  itemsAlignment: 'start',
  itemsDirection: 'row',
  itemsJustification: 'start',
};
ContainerFlex.propTypes = {
  centerText: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  itemsAlignment: PropTypes.oneOf([
    'baseline',
    'center',
    'end',
    'start',
    'stretch',
  ]),
  itemsDirection: PropTypes.oneOf([
    'column',
    'column-reverse',
    'row',
    'row-reverse',
  ]),
  itemsJustification: PropTypes.oneOf([
    'around',
    'between',
    'center',
    'end',
    'evenly',
    'start',
  ]),
};

export default ContainerFlex;
